import React, { useState } from "react"
import { Box } from "@chakra-ui/core"

export type FittingType = "E-Trike Fitting" | "E-Bike Fitting"

export const FITTING_FORM_URLS: Record<FittingType, string> = {
  "E-Trike Fitting":
    "https://docs.google.com/forms/d/e/1FAIpQLSfRAMghKZe7VqNtCxk_0rESMoM_Ue6HTeLIHY8IhivQ7rpz6Q/viewform",
  "E-Bike Fitting":
    "https://docs.google.com/forms/d/e/1FAIpQLSd5C0-Nm1QyCF4FxtjXD7xyOMuobgXSu7Z8JukgNogwf4sM1A/viewform",
}

export const TrikeIcon = () => (
  <svg width="42" height="32" viewBox="0 0 42 32" fill="none">
    <circle cx="8" cy="22" r="5.9" stroke="#00C4D1" strokeWidth="2.4" />
    <circle cx="32" cy="22" r="5.9" stroke="#00C4D1" strokeWidth="2.4" />
    <circle cx="20" cy="7" r="4.8" stroke="#00C4D1" strokeWidth="2.4" />
  </svg>
)

export const BikeIcon = () => (
  <svg width="42" height="32" viewBox="0 0 42 32" fill="none">
    <circle cx="10" cy="22" r="7" stroke="#00C4D1" strokeWidth="2.4" />
    <circle cx="32" cy="22" r="7" stroke="#00C4D1" strokeWidth="2.4" />
  </svg>
)

export const ChatIcon = () => (
  <svg width="18" height="16" viewBox="0 0 18 16" fill="none">
    <path
      d="M2.5 4.5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6.5a2 2 0 0 1-2 2H7l-4 3.2v-3.2H4.5a2 2 0 0 1-2-2z"
      stroke="#00C4D1"
      strokeWidth="1.7"
      strokeLinejoin="round"
    />
    <circle cx="6.5" cy="7.8" r="0.85" fill="#00C4D1" />
    <circle cx="9.2" cy="7.8" r="0.85" fill="#00C4D1" />
    <circle cx="11.9" cy="7.8" r="0.85" fill="#00C4D1" />
  </svg>
)

export const openZendeskChat = () => {
  // @ts-ignore
  const zE = window.zE
  if (typeof zE === "function") {
    zE("messenger", "open")
  }
}

export const openFittingForm = (fitting: FittingType) => {
  window.open(FITTING_FORM_URLS[fitting], "_blank", "noopener,noreferrer")
}

export const WidgetCloseButton = ({ onClick }: { onClick: () => void }) => (
  <Box
    as="button"
    aria-label="Close fitting consultation widget"
    position="absolute"
    top="15px"
    right="12px"
    w="30px"
    h="30px"
    borderRadius="8px"
    border="1px solid rgba(255,255,255,0.55)"
    bg="transparent"
    display="flex"
    alignItems="center"
    justifyContent="center"
    cursor="pointer"
    onClick={onClick}
  >
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
      <path
        d="M2 2L10 10M10 2L2 10"
        stroke="white"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  </Box>
)

export const useFittingConsultation = () => {
  const [isVisible, setIsVisible] = useState(true)

  const dismissWidget = () => {
    setIsVisible(false)
  }

  const handleFittingSelect = (fitting: FittingType) => {
    openFittingForm(fitting)
  }

  return {
    isVisible,
    dismissWidget,
    handleFittingSelect,
  }
}
